<template>
  <el-dialog
    :title="$t('deletePrivilegeGroup.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
  >
    <div class="modal-body">
      <p align="center">
        {{ $t('deletePrivilegeGroup.deleteWarning') }}，{{ $t('deletePrivilegeGroup.confirmDelete') }}{{ deletePrivilegeGroupInfo.name }}
      </p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('deletePrivilegeGroup.cancel') }}
      </el-button>
      <el-button type="primary" @click="deletePrivilegeGroup">
        {{ $t('deletePrivilegeGroup.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deletePrivilegeGroup } from '@/api/frame/privilegeGroupApi'

export default {
  name: 'DeletePrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      deletePrivilegeGroupInfo: {
        pgId: '',
        name: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deletePrivilegeGroupInfo = {
        pgId: row.pgId,
        name: row.name
      }
    },
    async deletePrivilegeGroup() {
      try {
        const res = await deletePrivilegeGroup(this.deletePrivilegeGroupInfo)
        
        if (res.code === 0) {
          this.$message.success(this.$t('deletePrivilegeGroup.deleteSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除权限组失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
.modal-body {
  text-align: center;
  padding: 20px;
}
</style>